import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CouponService } from 'src/app/services/coupon.service';

@Component({
  selector: 'app-delete-coupon',
  templateUrl: './delete-coupon.component.html',
  styleUrls: ['./delete-coupon.component.css']
})
export class DeleteCouponComponent implements OnInit {
  code: any;
  api_success: string;
  api_error: any;
  constructor(private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any, private couponService: CouponService) { }

  ngOnInit() {
    this.code = this.data;
  }
  onDeleteConfirm() {
    this.couponService.deleteCoupon(this.data)
      .subscribe(
        res => {
          this.api_success = 'Coupon deleted Successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
        (error) => {
          this.api_error = error.error;
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        }
      );
}
}

